/** Florida universities (SUS + major private colleges). */
export const FLORIDA_UNIVERSITY_IDS: number[] = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,
];

/** New York universities. */
export const NEW_YORK_UNIVERSITY_IDS: number[] = [
    106, 109, 110, 123, 131, 135, 136, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
    194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210,
];

/** New Jersey universities. */
export const NEW_JERSEY_UNIVERSITY_IDS: number[] = [
    132, 211, 212, 213, 214,
];

/** Connecticut universities. */
export const CONNECTICUT_UNIVERSITY_IDS: number[] = [
    150, 215, 216,
];

/**
 * Universities available for search, signup, create listing, and profile.
 * Florida + New York (and surrounding NJ/CT) are fully enabled.
 */
export const SUPPORTED_UNIVERSITY_IDS: number[] = [
    ...FLORIDA_UNIVERSITY_IDS,
    ...NEW_YORK_UNIVERSITY_IDS,
    ...NEW_JERSEY_UNIVERSITY_IDS,
    ...CONNECTICUT_UNIVERSITY_IDS,
];

/** NYC metro universities used when filtering city=New York City */
export const NYC_METRO_UNIVERSITY_IDS: number[] = [
    0, 106, 109, 123, 181, 182, 188, 189, 190, 191, 192, 193, 194, 195, 205, 206, 207, 208, 209, 210,
];

/** Tampa Bay universities used when filtering city=Tampa */
export const TAMPA_METRO_UNIVERSITY_IDS: number[] = [
    0, 10, 16, 21,
];
